import { initializeApp } from "firebase/app";
import {
    GoogleAuthProvider,
    connectAuthEmulator,
    getAuth,
} from "firebase/auth";

import config from "@/config";

const {
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
    emulatorUrl,
} = config.authentication.firebase;

export const provider = new GoogleAuthProvider();

const app = initializeApp({
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
});

export const firebaseAuth = getAuth(app);
firebaseAuth.useDeviceLanguage();

if (emulatorUrl) {
    connectAuthEmulator(firebaseAuth, emulatorUrl, { disableWarnings: true });
}
